export default "__VITE_ASSET__BnOxehAQ__"